<template>
  <div>
    <!-- Loader -->
    <div v-if="loading || creatingBlueprint" class="container max-w-screen-md pt-20 space-y-12" element-loading-background="rgba(255, 255, 255, 0.05)">
      <ContentLoader primaryColor="#f8efe6" secondaryColor="#f8efe655" class="w-full" :speed="1.5" :primaryOpacity="0.9" :secondaryOpacity="0.9" />
      <ContentLoader
        primaryColor="#f8efe6"
        secondaryColor="#f8efe655"
        class="w-full"
        :speed="1.5"
        :primaryOpacity="0.65"
        :secondaryOpacity="0.65"
      />
      <ContentLoader primaryColor="#f8efe6" secondaryColor="#f8efe655" class="w-full" :speed="2.5" :primaryOpacity="0.5" :secondaryOpacity="0.5" />
    </div>

    <!-- Empty State -->
    <BuildFirstFlowCard v-else-if="hasNoBlueprints" @start="createBlueprint" />

    <!-- Blueprint list -->
    <router-view v-else @createSegment="createSegment" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as actions from '@/store/action-types';
import BuildFirstFlowCard from '@/components/UI/BuildFirstFlowCard.vue';
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'Flows',
  components: {
    BuildFirstFlowCard,
    ContentLoader,
  },
  data() {
    return {
      loading: true,
      creatingBlueprint: false,
    };
  },
  async created() {
    await this.$store.dispatch(actions.SYNC_USER_RECORD);
    await this.$store.dispatch(actions.FETCH_ORG_PRICES);
    if (!this.$store.getters.segmentsEnabled) {
      // if only one primary blueprint, go to that page
      if (this.primaryBlueprintId) {
        this.$router.push({ name: 'builder', params: { id: this.primaryBlueprintId } });
      }
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters(['primaryBlueprintId', 'segmentsEnabled']),
    hasNoBlueprints() {
      return !this.primaryBlueprintId;
    },
  },
  methods: {
    async createBlueprint() {
      this.loading = true;
      this.creatingBlueprint = true;
      // create a blueprint if there isn't one
      if (!this.primaryBlueprintId) {
        await this.$store.dispatch(actions.CREATE_BLUEPRINT);
        await this.$store.dispatch(actions.SYNC_USER_RECORD);
      }
      this.$router.push({ name: 'builder', params: { id: this.primaryBlueprintId } });
    },
    async createSegment() {
      this.loading = true;
      this.creatingBlueprint = true;

      const segment = await this.$store.dispatch(actions.SEGMENT_CREATE);
      await this.$store.dispatch(actions.SYNC_USER_RECORD);

      const segmentBlueprint = segment.blueprints[0];
      this.$router.push({ name: 'builder', params: { id: segmentBlueprint } });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    padding-top: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .dialog-footer {
    border-radius: 0 0 10px 10px;
  }
  .el-dialog__headerbtn {
    display: none;
  }
  /* Fix Bouncing Loader Button */
  .el-button--primary:focus {
    outline: none;
  }
  .el-loading-mask:focus {
    outline: none;
  }
  .el-loading-spinner:focus {
    outline: none;
  }
  .el-loading-spinner .circular:focus {
    outline: none;
  }
}
</style>
